import { scheduleSentry } from './utils/deferred_sentry';
import { scheduleBootstrap } from './utils/session_bootstrap';
import * as Turbo from '@hotwired/turbo';
import './controllers/lead_funnel_controllers';

// Funnels consume HTTP Turbo Streams; they do not subscribe to Action Cable.
window.Turbo = Turbo;
scheduleSentry();
scheduleBootstrap();
